import { render } from "./footwearLayout.vue?vue&type=template&id=546929a9&scoped=true&ts=true"
import script from "./footwearLayout.vue?vue&type=script&lang=ts"
export * from "./footwearLayout.vue?vue&type=script&lang=ts"

import "./footwearLayout.vue?vue&type=style&index=0&id=546929a9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546929a9"]])

export default __exports__